import React, { useEffect, useState } from 'react';
import { ActionButtons } from '../Shared/ActionButtons';
import SubscriptionModal from './SubscriptionModal';
import { FormContextProvider } from '@sw-sw/lib-form';
import AddOnModal from './AddOnModal';
import SubscriptionCard from './SubscriptionCard';
import { useSubscription } from '../../hooks/subscription';
import Loading from '../Shared/ResourceIndex/Loading';
import { TooltipContextProvider } from '@sw-sw/lib-ui';
import AddUserRoleModal from './AddUserRoleModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import subscriptionApi from '../../utils/api/subscription';
import { toast } from 'react-toastify';

export default function Subscription() {
  const [showModal, setShowModal] = useState(false);
  const [isEditAction, setIsEditAction] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [showAddOnModal, setShowAddOnModal] = useState<boolean>(false);
  const [addOnList, setAddOnList] = useState<any>([]);
  const [selectedAddOnModalDetails, setSelectedAddOnModalDetails] =
    useState(null);
  const [showUserRoleModal, setShowUserRoleModal] = useState<boolean>(false);
  const [userRolesList, setUserRolesList] = useState<any>([]);
  const [selectedAddUserRoleModalDetails, setSelectedAddUserRoleModalDetails] =
    useState<any>(null);
  const subscriptionQuery = useSubscription();
  const [subscriptions, setSubscriptions] = useState(
    subscriptionQuery.data || [],
  );

  useEffect(() => {
    if (subscriptionQuery.data) {
      setSubscriptions(subscriptionQuery.data);
    }
  }, [subscriptionQuery.data]);

  const handleOnCreateNew = () => {
    setSelectedSubscription(null);
    setShowModal(true);
    setIsEditAction(false);
    setSelectedAddOnModalDetails(null);
    setAddOnList([]);
    setUserRolesList([]);
    setSelectedAddUserRoleModalDetails(null);
  };

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const reorderedSubscriptions = [...subscriptions];
    const [movedItem] = reorderedSubscriptions.splice(result.source.index, 1);
    reorderedSubscriptions.splice(result.destination.index, 0, movedItem);
    const orderedData = reorderedSubscriptions.map((item, index) => ({
      id: item.id,
      order: index + 1,
    }));

    subscriptionApi.changeOrder(orderedData).then(() => {
      toast.success('Subscription order updated successfully');
    });
    setSubscriptions(reorderedSubscriptions);
  };

  if (!subscriptionQuery.data || subscriptionQuery.isLoading) {
    return <Loading what='Subscriptions' />;
  }

  return (
    <div className='subscription-container'>
      <div className='subscription-container__header'>
        <h3>Subscription Plans</h3>
        <ActionButtons
          className='subscription-container__button'
          primary='Create New Plan +'
          onClick={handleOnCreateNew}
        />
      </div>

      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId='subscriptions'>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className='droppable-area'
            >
              {subscriptions.map((subscription: any, index: any) => (
                <Draggable
                  key={String(subscription.id)}
                  draggableId={String(subscription.id)}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        opacity: snapshot.isDragging ? 0.8 : 1,
                      }}
                      className='draggable-item'
                    >
                      <SubscriptionCard
                        key={subscription.id}
                        name={subscription.name}
                        description={subscription.description}
                        price={subscription.price}
                        addOnList={subscription.addons}
                        subscriptionType={subscription.subscription_type}
                        type={'edit'}
                        handleButtonClick={() => {
                          setSelectedSubscription(subscription);
                          setShowModal(true);
                          setIsEditAction(true);
                          setAddOnList(subscription.addons);
                          setUserRolesList(subscription.subscriptionRoles);
                        }}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {showModal && (
        <FormContextProvider>
          <SubscriptionModal
            isEditAction={isEditAction}
            setShowModal={setShowModal}
            selectedSubscription={selectedSubscription}
            setShowAddOnModal={setShowAddOnModal}
            addOnList={addOnList}
            setAddOnList={setAddOnList}
            setSelectedAddOnModalDetails={setSelectedAddOnModalDetails}
            setShowUserRoleModal={setShowUserRoleModal}
            userRolesList={userRolesList}
            setSelectedAddUserRoleModalDetails={
              setSelectedAddUserRoleModalDetails
            }
            subscriptionQuery={subscriptionQuery}
          />
        </FormContextProvider>
      )}

      {showAddOnModal && (
        <TooltipContextProvider>
          <FormContextProvider>
            <AddOnModal
              isEditAction={selectedAddOnModalDetails ? true : false}
              selectedAddOnModalDetails={selectedAddOnModalDetails}
              setShowAddOnModal={setShowAddOnModal}
              setAddOnList={setAddOnList}
              setSelectedAddOnModalDetails={setSelectedAddOnModalDetails}
            />
          </FormContextProvider>
        </TooltipContextProvider>
      )}

      {showUserRoleModal && (
        <FormContextProvider>
          <AddUserRoleModal
            isEditAction={selectedAddUserRoleModalDetails ? true : false}
            selectedAddUserModalDetails={selectedAddUserRoleModalDetails}
            setShowUserRoleModal={setShowUserRoleModal}
            setSelectedAddOnModalDetails={setSelectedAddOnModalDetails}
            setUserRolesList={setUserRolesList}
          />
        </FormContextProvider>
      )}
    </div>
  );
}
